<div>{{version}}</div>
